import { Outlet, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { Menu } from "lucide-react";
import Sidebar from "@/components/Sidebar";
import Logo from "@/components/Logo";
import { NotificationCenterBell } from "@/components/NotificationCenterBell";
import api from "@/lib/api";

export default function DashboardLayout({ children }) {
  const { slug } = useParams();
  const [tenant, setTenant] = useState(null);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    // For slug routes: fetch the tenant by slug (public endpoint, no auth needed).
    // For admin routes (no slug in URL): fetch admin's current-tenant default.
    if (slug) {
      api.get(`/tenants/by-slug/${slug}`).then(({ data }) => setTenant(data)).catch(() => setTenant(null));
    } else {
      api.get("/tenants/current").then(({ data }) => setTenant(data)).catch(() => setTenant(null));
    }
  }, [slug]);

  return (
    <div className="min-h-screen flex" data-testid="dashboard-shell">
      <Sidebar tenant={tenant} isOpen={mobileOpen} onClose={() => setMobileOpen(false)} />
      <main className="flex-1 bg-[color:var(--cc-paper)] min-w-0 w-full">
        <div
          className="sticky top-0 z-20 flex items-center justify-between lg:justify-end px-4 py-3 lg:py-2 bg-white border-b border-[#e7e9ee]"
          data-testid="mobile-topbar"
        >
          <button
            onClick={() => setMobileOpen(true)}
            data-testid="mobile-menu-btn"
            className="lg:hidden p-2 -ml-2 rounded-md hover:bg-[#f5f6f8]"
            aria-label="Open menu"
          >
            <Menu size={20} strokeWidth={1.6} />
          </button>
          <span className="lg:hidden"><Logo tone="light" withWordmark /></span>
          <NotificationCenterBell />
        </div>

        <div className="max-w-[1280px] mx-auto px-4 sm:px-6 lg:px-8 py-6 lg:py-8">
          {children || <Outlet context={{ tenant, slug }} />}
        </div>
      </main>
    </div>
  );
}
